import React from 'react';
import PropTypes from 'prop-types';

const generateSrcset = images => {
    const parts = [];

    images.forEach(image => {
        parts.push(`${image.src}&dpr=1&q=80 ${image.width * 1}w`);
        parts.push(`${image.src}&dpr=2&q=65 ${image.width * 2}w`);
        parts.push(`${image.src}&dpr=3&q=40 ${image.width * 3}w`);
    });

    return parts.join(', ');
};

const generateSizes = images => {
    const parts = [];

    images.forEach(image => {
        parts.push(image.breakpoint);
    });

    return parts.join(', ');
};

const ResponsiveImage = ({
    className,
    images,
    width,
    height,
    alt,
    role,
    loading,
}) => {
    const src = `${images[images.length - 1].src}&dpr=1&q=80`;

    return (
        <img
            className={className}
            src={src}
            srcSet={generateSrcset(images)}
            sizes={generateSizes(images)}
            width={width}
            height={height}
            alt={alt}
            role={role}
            loading={loading}
        />
    );
};

ResponsiveImage.propTypes = {
    className: PropTypes.string,
    images: PropTypes.arrayOf(
        PropTypes.shape({
            src: PropTypes.string.isRequired,
            width: PropTypes.number.isRequired,
            breakpoint: PropTypes.string,
        }),
    ).isRequired,
    width: PropTypes.number,
    height: PropTypes.number,
    alt: PropTypes.string,
    role: PropTypes.string,
    loading: PropTypes.string,
};

ResponsiveImage.defaultProps = {
    className: '',
    width: 0,
    height: 0,
    alt: '',
    role: '',
    loading: 'lazy',
};

export { ResponsiveImage };
